import { Autocomplete, AutocompleteProps, AutocompleteRenderInputParams } from "@mui/material"
import { isUndefined } from "lodash"
import React from "react"
import BaseTextField from "./BaseTextField"

export interface BaseAutocompleteProps<T, Multiple extends boolean | undefined>
    extends Omit<AutocompleteProps<T, Multiple, false, false, "div">, "renderInput"> {
    label: string,
    renderInput?: (params: AutocompleteRenderInputParams) => React.ReactNode,
    required?: boolean,
    error?: boolean,
    size?: "medium" | "small"
}

const BaseAutocomplete = <T, Multiple extends boolean | undefined>(props: BaseAutocompleteProps<T, Multiple>) => {

    let { label, renderInput, size, required, error, ...fwdProps } = props;

    if (isUndefined(renderInput))
        renderInput = (params) => <BaseTextField {...params} label={label} error={error} required={required} />

    return (
        <Autocomplete
            {...fwdProps}
            renderInput={renderInput}
            size={size}
        />
    )
}

export default BaseAutocomplete
